// src/app/layout/CoreWorkspace.tsx
import { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PageProgress } from '../components/foundation';

/**
 * The routed main-content region of CoreLayout. Owns only the
 * scroll/padding frame around <Outlet/> — individual feature pages
 * still own their own internal layout (PageContainer/PageHeader),
 * exactly like Step 1's `<main>` inside AppLayout. Split into its own
 * component (rather than left inline in CoreLayout) so the
 * CoreLayout -> CoreSidebar / CoreHeader / CoreWorkspace tree the
 * brief specifies is real, not just a comment.
 */
export function CoreWorkspace() {
  const location = useLocation();
  const firstRender = useRef(true);
  const [routeLoading, setRouteLoading] = useState(false);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return undefined;
    }

    setRouteLoading(true);
    const timeout = window.setTimeout(() => setRouteLoading(false), 220);
    return () => window.clearTimeout(timeout);
  }, [location.key]);

  return (
    <main className="vania-shell-workspace" aria-busy={routeLoading || undefined}>
      <PageProgress active={routeLoading} />
      <Outlet />
    </main>
  );
}
